<template>
	<img :src="src" />
</template>

<script>
export default {
	name: "Toggle",
	props: {
		visible: Boolean
	},
	computed: {
		src() {
			//return require("@/assets/button_down.png");

			if (this.visible) {
				return require('@/assets/button_up.png')
			} else {
				return require('@/assets/button_down.png');
			}
		}
	}
};
</script>

<style scoped>
img {
	height: 20px;
	width: 20px;
}
</style>
